/** AK-47. 7.62x39 mm: hits harder than the M4, climbs harder, and reaches a little less far. */

import type { WeaponSpec } from '@/sim/weapons/weaponContract';

export const AK47 = {
  id: 'ak47',
  label: 'AK-47',
  classId: 'rifle',
  caliber: '7.62x39 mm',
  fireMode: 'auto',
  roundsPerMinute: 600,
  magSize: 30,
  reserveAmmo: 120,
  reloadSeconds: 2.6,
  emptyReloadSeconds: 3.3,
  reloadStyle: 'magazine',
  damage: 41,
  damageTypeId: 'ballistic',
  falloff: { fullMetres: 50, zeroMetres: 280, minScale: 0.5 },
  pellets: 1,
  adsSpreadMoa: 4.5,
  hipSpreadMoa: 135,
  bloomMoaPerShot: 9,
  bloomMoaCap: 65,
  bloomDecayMoaPerSecond: 75,
  moveSpreadMoaPerMps: 28,
  crouchSpreadScale: 0.6,
  airborneSpreadMoa: 95,
  // Straight up for the first few, then a wide walk to the right that never quite comes back.
  recoilPattern: [
    { pitch: 1.3, yaw: 0.08 },
    { pitch: 1.2, yaw: 0.12 },
    { pitch: 1.1, yaw: 0.22 },
    { pitch: 1.0, yaw: 0.36 },
    { pitch: 0.92, yaw: 0.42 },
    { pitch: 0.86, yaw: 0.3 },
    { pitch: 0.82, yaw: 0.1 },
    { pitch: 0.8, yaw: -0.16 },
    { pitch: 0.78, yaw: -0.3 },
    { pitch: 0.76, yaw: -0.12 },
    { pitch: 0.74, yaw: 0.18 },
    { pitch: 0.72, yaw: 0.34 },
  ],
  recoilResetSeconds: 0.32,
  recoilRecoveryPerSecond: 6,
  adsFovDegrees: 48,
  adsSeconds: 0.24,
  adsSensitivityScale: 0.65,
  muzzleVelocity: 715,
} as const satisfies WeaponSpec;
